import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveAttachmentFromAccount as RemoveAttachmentFromAccountMutation,
    RemoveAttachmentFromAccountVariables,
    AccountFileRemoveInput,
} from 'nutshell-graphql-types';

import REMOVE_ATTACHMENT_FROM_ACCOUNT from '../mutations/remove-attachment-from-account.graphql';

export const useRemoveAttachmentFromAccount = (): {
    removeAttachmentFromAccount: (arg1: AccountFileRemoveInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeAttachmentFromAccount, {loading, error}] = useMutation<
        RemoveAttachmentFromAccountMutation,
        RemoveAttachmentFromAccountVariables
    >(REMOVE_ATTACHMENT_FROM_ACCOUNT);

    return {
        removeAttachmentFromAccount: (input: AccountFileRemoveInput) =>
            removeAttachmentFromAccount({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
